import { request } from "@/utils/request";

export const tfByCategoryAndFamily = (type) => {
  return request.get(`/tf/tfByCategoryAndFamily?type=${type}`);
};

export const categoriesByFamily = (type) => {
  return request.get(`/tf/categoriesByFamily?type=${type}`);
};

export const tfSearch = ({ page, limit, data }) => {
  return request.post(`/tf/tfSearch?page=${page}&limit=${limit}`, data);
};
